import React from "react";

const InflowSvg: React.FC = () => {
	return (
		<svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="18" 
            height="15" 
            viewBox="0 0 18 15" 
            fill="none"
        >
			<path
				d="M1.00005 2.6625L2.82005 1.2625C3.27005 0.9125 3.90005 0.9125 4.35005 1.2625L5.53005 2.1725C5.98005 2.5225 6.61005 2.5225 7.06005 2.1725L8.18005 1.3025C8.63005 0.9525 9.26005 0.9525 9.71005 1.3025L10.74 2.0925C11.19 2.4425 11.8201 2.4425 12.2701 2.0925L13.34 1.2725C13.79 0.9225 14.42 0.9225 14.87 1.2725L16.7001 2.6825"
				fill="white"
			/>
			<path
				d="M1.00005 7.8525L2.82005 6.4525C3.27005 6.1025 3.90005 6.1025 4.35005 6.4525L5.53005 7.3625C5.98005 7.7125 6.61005 7.7125 7.06005 7.3625L8.18005 6.4925C8.63005 6.1425 9.26005 6.1425 9.71005 6.4925L10.74 7.2825C11.19 7.6325 11.8201 7.6325 12.2701 7.2825L13.34 6.4625C13.79 6.1125 14.42 6.1125 14.87 6.4625L16.7001 7.8725"
				fill="white"
			/>
			<path
				d="M1.00005 13.0425L2.82005 11.6425C3.27005 11.2925 3.90005 11.2925 4.35005 11.6425L5.53005 12.5525C5.98005 12.9025 6.61005 12.9025 7.06005 12.5525L8.18005 11.6825C8.63005 11.3325 9.26005 11.3325 9.71005 11.6825L10.74 12.4725C11.19 12.8225 11.8201 12.8225 12.2701 12.4725L13.34 11.6525C13.79 11.3025 14.42 11.3025 14.87 11.6525L16.7001 13.0625"
				fill="white"
			/>
			<path
				d="M1.00005 2.6625L2.82005 1.2625C3.27005 0.9125 3.90005 0.9125 4.35005 1.2625L5.53005 2.1725C5.98005 2.5225 6.61005 2.5225 7.06005 2.1725L8.18005 1.3025C8.63005 0.9525 9.26005 0.9525 9.71005 1.3025L10.74 2.0925C11.19 2.4425 11.8201 2.4425 12.2701 2.0925L13.34 1.2725C13.79 0.9225 14.42 0.9225 14.87 1.2725L16.7001 2.6825M1.00005 7.8525L2.82005 6.4525C3.27005 6.1025 3.90005 6.1025 4.35005 6.4525L5.53005 7.3625C5.98005 7.7125 6.61005 7.7125 7.06005 7.3625L8.18005 6.4925C8.63005 6.1425 9.26005 6.1425 9.71005 6.4925L10.74 7.2825C11.19 7.6325 11.8201 7.6325 12.2701 7.2825L13.34 6.4625C13.79 6.1125 14.42 6.1125 14.87 6.4625L16.7001 7.8725M1.00005 13.0425L2.82005 11.6425C3.27005 11.2925 3.90005 11.2925 4.35005 11.6425L5.53005 12.5525C5.98005 12.9025 6.61005 12.9025 7.06005 12.5525L8.18005 11.6825C8.63005 11.3325 9.26005 11.3325 9.71005 11.6825L10.74 12.4725C11.19 12.8225 11.8201 12.8225 12.2701 12.4725L13.34 11.6525C13.79 11.3025 14.42 11.3025 14.87 11.6525L16.7001 13.0625"
				stroke="black"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
};

export default InflowSvg;
